<div class="company-detail-container view">
  @if (isLoading) {
    <div class="loading">
      <mat-spinner color="accent" diameter="40"></mat-spinner>
      <p>Loading company details...</p>
    </div>
  }

  @if (error) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <p>{{ error }}</p>
    </div>
  }

  @if (!isLoading && company) {
    <mat-card class="cardPlain">
      <div class="custom-card-header">
        <div class="section-header">
          <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
          <h1 class="m-0 f-w-500">{{ company.company_name }}</h1>
          <p class="m-0 help-text">Org number: {{ company.company_id }}</p>
        </div>

        <span class="spacer"></span>

        <button
          (click)="goBack()"
          class="d-inline-flex align-items-center gap-6"
          color="primary"
          mat-stroked-button
          type="button"
        >
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
      </div>

      <mat-card-content class="d-flex flex-col gap-24">
        <section class="tab-section d-flex flex-col gap-16">
          <div class="section-header">
            <h4 class="m-0 f-s-16 f-w-600">Company</h4>
          </div>

          <div class="details-grid">
            <div class="detail-item">
              <div class="detail-label">Organization number</div>
              <div class="detail-value">{{ company.company_id }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Website</div>
              <div class="detail-value">
                @if (websiteHref(company.website_url)) {
                  <a
                    [href]="websiteHref(company.website_url)"
                    rel="noopener noreferrer"
                    target="_blank"
                    >{{ company.website_url }}</a
                  >
                } @else {
                  N/A
                }
              </div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Phone</div>
              <div class="detail-value">{{ company.phone_number ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Founded</div>
              <div class="detail-value">
                {{ company.date_founded ? (company.date_founded | date: 'longDate') : 'N/A' }}
              </div>
            </div>

            <div class="detail-item full-width">
              <div class="detail-label">Address</div>
              <div class="detail-value">
                {{ company.postal_street_address ?? '' }}
                {{ company.postal_street_address ? ',' : '' }}
                {{ company.postal_code ?? '' }}
                {{ company.postal_code ? ' ' : '' }}
                {{ company.city ?? company.postal_place ?? '' }}
                @if (!company.postal_street_address && !company.postal_code && !(company.city ?? company.postal_place)) {
                  N/A
                }
              </div>
            </div>

            @if (company.business_purpose_text) {
              <div class="detail-item full-width">
                <div class="detail-label">Business purpose</div>
                <div class="detail-value">{{ company.business_purpose_text }}</div>
              </div>
            }
          </div>
        </section>

        <section class="tab-section d-flex flex-col gap-16">
          <div class="section-header">
            <h4 class="m-0 f-s-16 f-w-600">Enrichment</h4>
            <p class="m-0 f-s-14 text-gray-100">Fields commonly used in the search and import flow.</p>
          </div>

          <div class="details-grid">
            <div class="detail-item">
              <div class="detail-label">NACE code</div>
              <div class="detail-value">{{ company.nace_code1 ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Employees</div>
              <div class="detail-value">{{ company.number_of_employees_group ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Latest accounts (year)</div>
              <div class="detail-value">{{ company.accounting_year ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">VAT registered</div>
              <div class="detail-value">
                {{ company.vat_registered === true ? 'Yes' : company.vat_registered === false ? 'No' : 'N/A' }}
              </div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Annual revenue</div>
              <div class="detail-value">{{ company.latest_annual_revenue ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">EBIT</div>
              <div class="detail-value">{{ company.latest_ebit ?? 'N/A' }}</div>
            </div>

            <div class="detail-item">
              <div class="detail-label">Equity</div>
              <div class="detail-value">{{ company.latest_sum_equity ?? 'N/A' }}</div>
            </div>
          </div>
        </section>
      </mat-card-content>
    </mat-card>
  }

  @if (!isLoading && !company && !error) {
    <div aria-live="polite" class="empty-state" role="region">
      <h3 class="title">Not found</h3>
      <p class="description">This company could not be loaded.</p>
    </div>
  }
</div>
